import {WBIcon} from '@wandb/ui';
import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

import {REPORT_FONT_SIZE} from '../constants';
import {deepLinkBlockWrapperStyles, StyledLinkButton} from '../deepLinkBlock';

export const DeepLink = styled(WBIcon).attrs({
  name: 'link',
})`
  position: absolute;
  font-size: 18px;
  color: #999;
  cursor: pointer;
  width: 24px;
  height: 100%;
  left: -46px;
  padding-left: 4px;
  &::before {
    padding-top: 4px;
    width: 18px;
    height: 18px;
  }
  &:hover {
    color: black;
  }
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const HeadingCollapser = styled(WBIcon).attrs({
  name: 'chevron-expanded',
})<{$collapsed: boolean}>`
  position: absolute;
  font-size: 22px;
  color: #999;
  cursor: pointer;
  left: 8px;
  &::before {
    width: 22px;
    height: 22px;
  }
  ${props =>
    props.$collapsed &&
    css`
      &::before {
        display: block;
        transform: rotate(-90deg);
      }
    `}
  &:hover {
    color: black;
  }
  && {
    width: 24px;
    height: 100%;
  }
`;

export const commonHeadingStyles = css`
  font-family: Source Serif Pro;
  ${deepLinkBlockWrapperStyles}
`;

/** Our SEO consultant says multiple h1's hurt SEO, so secretly downlevel all headers */
export const HeadingOne = styled.h2`
  font-size: ${Math.round(REPORT_FONT_SIZE * 2)}px;
  margin-bottom: ${Math.round(REPORT_FONT_SIZE * 0.5)}px !important;
  margin-top: ${Math.round(REPORT_FONT_SIZE * 1.9)}px !important;
  ${HeadingCollapser}, ${DeepLink} {
    padding-top: ${REPORT_FONT_SIZE * 0.42}px;
  }
  ${StyledLinkButton} {
    top: ${REPORT_FONT_SIZE * 0.48}px;
  }
  ${commonHeadingStyles}
  @media only screen and (max-width: 768px) {
    font-size: ${Math.round(REPORT_FONT_SIZE * 1.7)}px;
    color: ${globals.gray700};
  }
`;
export const HeadingTwo = styled.h3`
  font-size: ${Math.round(REPORT_FONT_SIZE * 1.5)}px;
  margin-bottom: ${Math.round(REPORT_FONT_SIZE * 0.4)}px !important;
  margin-top: ${Math.round(REPORT_FONT_SIZE * 1.4)}px !important;
  ${HeadingCollapser}, ${DeepLink} {
    padding-top: ${REPORT_FONT_SIZE * 0.25}px;
  }
  ${StyledLinkButton} {
    top: ${REPORT_FONT_SIZE * 0.3}px;
  }
  ${commonHeadingStyles}
  @media only screen and (max-width: 768px) {
    font-size: ${Math.round(REPORT_FONT_SIZE * 1.3)}px;
    font-weight: 600;
    color: ${globals.gray700};
  }
`;
export const HeadingThree = styled.h4`
  font-size: ${Math.round(REPORT_FONT_SIZE * 1.3)}px;
  margin-bottom: ${Math.round(REPORT_FONT_SIZE * 0.4)}px !important;
  margin-top: ${Math.round(REPORT_FONT_SIZE * 1.1)}px !important;
  ${HeadingCollapser}, ${DeepLink} {
    padding-top: ${REPORT_FONT_SIZE * 0.15}px;
  }
  ${StyledLinkButton} {
    top: ${REPORT_FONT_SIZE * 0.2}px;
  }
  ${commonHeadingStyles}
  @media only screen and (max-width: 768px) {
    font-size: ${Math.round(REPORT_FONT_SIZE * 1.1)}px;
    font-weight: 600;
    color: ${globals.gray700};
    margin-top: ${Math.round(REPORT_FONT_SIZE * 1.5)}px !important;
  }
`;
export const HeadingFour = styled.h5`
  font-size: ${Math.round(REPORT_FONT_SIZE * 1)}px;
  margin-bottom: ${Math.round(REPORT_FONT_SIZE * 0.4)}px !important;
  margin-top: ${Math.round(REPORT_FONT_SIZE * 0.9)}px;
`;
